import React, {Fragment} from "react";
import {BrowserRouter, Link, Route, Switch} from "react-router-dom";
import Home from "../views/Authorised/Home";
import Logout from "../views/Authorised/Logout";
import {Button, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Nav} from "reactstrap";
import ChangePassword from "../views/Authorised/ChangePassword";
import Register from "../views/Register/Register";
import UserSessionService from "../services/UserSessionService";
import AgentPrivilege from "../enum/AgentPrivilege";
import '../scss/Menu.css';
import CustomerSearch from "../views/Customer/CustomerSearch";
import CustomerIndex from "../views/Customer/CustomerIndex";
import CardBatchSearch from "../views/CardBatchSearch";
import CommissionSummaryIndex from "../views/Commission/CommissionSummaryIndex";
import PaymentDetailsIndex from "../views/PaymentDetails/PaymentDetailsIndex";
import ChatSingle from "../views/Chat/ChatSingle";
import ChatsOpen from "../views/Chat/ChatsOpen";
import ChatConversationService from "../services/chat/ChatConversationService";
import ChatsHistory from "../views/Chat/ChatsHistory";
import AgentAnnouncementIndex from "../views/AgentAnnouncements/AgentAnnouncementIndex";
import SendAgentLinkModalComponent from "./SendAgentLinkModalComponenent";
import AgentIndex from "../views/AgentOnBoarding/AgentIndex";
import ProfileIndex from "../views/Profile/ProfileIndex";

class AuthenticatedRouter extends React.Component {

    constructor(props) {
        super(props);
        let user = UserSessionService.getUser();
        this.username = user.username;
        this.agentCanViewCustomers = UserSessionService.hasPrivilege(AgentPrivilege.AGENT_PORTAL_CUSTOMER_VIEW);
        this.agentCanCreateRegistrations = UserSessionService.hasPrivilege(AgentPrivilege.AGENT_PORTAL_REGISTRATION_CREATE);
        this.agentCanViewCardBatches = UserSessionService.hasPrivilege(AgentPrivilege.AGENT_PORTAL_CARD_BATCH_VIEW);
        this.agentCanViewCommissions = UserSessionService.hasPrivilege(AgentPrivilege.AGENT_PORTAL_OUTBOUND_TRANSACTION_COMMISSION_SUMMARY_VIEW);
        this.agentCanViewAndEditPaymentDetails = UserSessionService.hasPrivilege(AgentPrivilege.AGENT_PORTAL_AGENT_PAYMENT_DETAILS_EDIT);
        this.agentHasChatPrivilege = UserSessionService.hasPrivilege(AgentPrivilege.AGENT_PORTAL_CHAT_VIEW);
        this.agentCanViewAnnouncements = UserSessionService.hasPrivilege(AgentPrivilege.AGENT_PORTAL_AGENT_ANNOUNCEMENT_VIEW);
        this.agentCanGenerateReferralLink = UserSessionService.hasPrivilege(AgentPrivilege.AGENT_PORTAL_GENERATE_REFERRAL_LINK)
        this.agentCanManageAgents = UserSessionService.hasPrivilege(AgentPrivilege.AGENT_PORTAL_MANAGED_AGENTS_MENU)
        this.agentCanViewProfile = UserSessionService.hasPrivilege(AgentPrivilege.AGENT_PORTAL_VIEW_PROFILE)

        let agentOrganisationId = user.user.organisationId;
        let organisationsCanTransactIds = process.env.REACT_APP_ORGANISATIONS_CAN_TRANSACT_IDS;
        let organisationsCanTransactIdsArray = organisationsCanTransactIds.split(",");
        let organisationsCanTransactIdsArrayIncludesAgentOrganisation = organisationsCanTransactIdsArray.includes(agentOrganisationId + '')
        this.agentCanChat = !organisationsCanTransactIdsArrayIncludesAgentOrganisation && this.agentHasChatPrivilege;

        this.checkForUnreadInterval = process.env.REACT_APP_CHAT_CHECK_UNREAD_INTERVAL * 1000;

        this.state = {
            selectedIndex: 3,
            menuIsOpen: false,
            headerText: "Dashboard",
            numberOfConversationsWithUnreadMessages: 0,
            openSendRegistrationLink: false,
            dropdownOpen: false
        };

        this.updateIndex = this.updateIndex.bind(this);
        this.onMenuToggleClick = this.onMenuToggleClick.bind(this);
        this.checkingForUnreadConversations = this.checkingForUnreadConversations.bind(this);
        this.toggleSendRegistrationLink = this.toggleSendRegistrationLink.bind(this)
    }

    updateIndex(selectedIndex) {
        this.setState({selectedIndex})
    }

    componentDidMount() {
        if (this.agentCanChat) {
            this.startCheckingForUnreadConversations();
        }
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    startCheckingForUnreadConversations() {
        this.checkingForUnreadConversations();
        this.interval = setInterval(this.checkingForUnreadConversations, this.checkForUnreadInterval); // Runs every minute
    }

    checkingForUnreadConversations() {
        ChatConversationService.retrieveUnreadConversationCountForUser(UserSessionService.getUser().user.id).then(
            response => {
                if (response.count !== undefined && response.count !== null) {
                    this.setState({
                        numberOfConversationsWithUnreadMessages: response.count
                    });
                }
            }
        )
    }

    renderMobileSideMenu() {
        return <div className={"side_menu"}
                    hidden={!this.state.menuIsOpen}
        >
            <div className={"side_menu_top_div"}>
                <img className={"sideMenuLogo"}
                     src={"/images/ria-logo.png"}
                     alt=""
                />
                <Button className={"fa fa-angle-double-left back_button"}
                        onClick={this.onMenuToggleClick.bind(this)}/>
            </div>

            <ul className={"side_bar_list"}>
                <li className={"side_bar_item"}>
                    <Link className={"side_bar_link"} to="/" onClick={this.onMenuToggleClick.bind(this)}>
                        <div className={"fa fa-bar-chart side_bar_image"}/>
                        {"Dashboard"}
                    </Link>
                </li>
                {this.agentCanManageAgents &&
                    <li className={"side_bar_item"}>
                        <Link className={"side_bar_link"} to="/agents"
                              onClick={this.onMenuToggleClick.bind(this)}>
                            <div className={"fa fa-users side_bar_image"}/>
                            {"My Agents"}
                        </Link>
                    </li>
                }

                {this.agentCanViewCommissions &&
                    <li className={"side_bar_item"}>
                        <Link className={"side_bar_link"} to="/commission"
                              onClick={this.onMenuToggleClick.bind(this)}>
                            <div className={"fa fa-money side_bar_image"}/>
                            {"Commission"}
                        </Link>
                    </li>
                }

                {this.agentCanCreateRegistrations &&
                    <li className={"side_bar_item"}>
                        <Link className={"side_bar_link"} to="/new-registration"
                              onClick={this.onMenuToggleClick.bind(this)}>
                            <div className={"fa fa-id-card side_bar_image"}/>
                            {"New Registration"}
                        </Link>
                    </li>}

                {this.agentCanGenerateReferralLink &&
                    <li className={"side_bar_item"}>
                        <Link className={"side_bar_link"} to="/new-registration"
                              onClick={this.toggleSendRegistrationLink}>
                            <div className={"fa fa-paper-plane side_bar_image"}/>
                            {"Send Registration Link"}
                        </Link>
                    </li>
                }

                {this.agentCanViewCustomers &&
                    <li className={"side_bar_item"}>
                        <Link className={"side_bar_link"} to="/customer"
                              onClick={this.onMenuToggleClick.bind(this)}>
                            <div className={"fa fa-users side_bar_image"}/>
                            {"My Customers"}
                        </Link>
                    </li>
                }
                {this.agentCanViewAndEditPaymentDetails &&
                    <li className={"side_bar_item"}>
                        <Link className={"side_bar_link"} to="/payment-details"
                              onClick={this.onMenuToggleClick.bind(this)}>
                            <div className={"fa fa-address-book side_bar_image"}/>
                            {"Payment Details"}
                        </Link>
                    </li>
                }
                {
                    this.agentCanViewCardBatches &&
                    <li className={"side_bar_item"}>
                        <Link className={"side_bar_link"} to="/card-batch"
                              onClick={this.onMenuToggleClick.bind(this)}>
                            <div className={"fa fa-dropbox side_bar_image"}/>
                            {"Card Batches"}
                        </Link>
                    </li>
                }
                {
                    this.agentCanChat &&
                    <li className={"side_bar_item"}>
                        <Link className={"side_bar_link"} to="/chat"
                              onClick={this.onMenuToggleClick.bind(this)}>
                            <div className={"fa fa-comment side_bar_image"}/>
                            {"Chat"}
                            {
                                this.state.numberOfConversationsWithUnreadMessages > 0 && <div
                                    style={{
                                        padding: 0,
                                        borderRadius: 50,
                                        maxWidth: 30,
                                        maxHeight: 30,
                                        minWidth: 30,
                                        minHeight: 30,
                                        textAlign: 'center',
                                        float: 'right'
                                    }}
                                    className={"btn-primary"}
                                >
                                    <span>{this.state.numberOfConversationsWithUnreadMessages}</span>
                                </div>
                            }
                        </Link>
                    </li>
                }
                {
                    this.agentCanViewAnnouncements &&
                    <li className={"side_bar_item"}>
                        <Link className={"side_bar_link"} to="/announcements"
                              onClick={this.onMenuToggleClick.bind(this)}>
                            <div className={"fa fa-bullhorn side_bar_image"}/>
                            {"Announcements"}
                        </Link>
                    </li>
                }
                <li className={"side_bar_item"}>
                    <Link className={"side_bar_link"} to="/change-password"
                          onClick={this.onMenuToggleClick.bind(this)}>
                        <div className={"fa fa-edit side_bar_image"}/>
                        {"Change Password"}
                    </Link>
                </li>
                <li className={"side_bar_item"}>
                    <Link className={"side_bar_link"} to="/logout"
                          onClick={this.onMenuToggleClick.bind(this)}>
                        <div className={"fa fa-lock side_bar_image"}/>
                        {"Logout"}
                    </Link>
                </li>
            </ul>

             <div className={"powered-by-section"}>
                    <p>Powered by Sikhona Forex</p>
                </div>

        </div>
    }

    onMenuToggleClick() {
        this.setState({
            menuIsOpen: !this.state.menuIsOpen
        });
    }

    toggleSendRegistrationLink() {
        this.setState({
            openSendRegistrationLink: !this.state.openSendRegistrationLink
        });
    }

    changeHeader(newHeader) {
        this.setState({
            headerText: newHeader
        })
    }

    render() {

        let childProps = {
            ...this.props.childProps,
            changeHeader: this.changeHeader.bind(this)
        };

        return <Fragment>
            <BrowserRouter>
                <div style={{backgroundColor: "#fafafa"}}>

                    {this.renderHeader()}

                    {this.renderMobileSideMenu()}
                    {this.state.menuIsOpen &&
                        <div className={"fade_sheet"} onClick={this.onMenuToggleClick}/>
                    }

                    <div className={"container-fluid"}>

                        <Switch>
                            <Route path="/commission">
                                <CommissionSummaryIndex {...childProps} />
                            </Route>
                            <Route path="/agents">
                                <AgentIndex {...childProps}/>
                            </Route>
                            <Route path="/new-registration">
                                <Register {...childProps} />
                            </Route>
                            <Route path="/customer/:registrationId/:view">
                                <CustomerIndex {...childProps}/>
                            </Route>
                            <Route path="/customer">
                                <CustomerSearch {...childProps}/>
                            </Route>
                            <Route path="/payment-details">
                                <PaymentDetailsIndex {...childProps}/>
                            </Route>
                            <Route path="/card-batch">
                                <CardBatchSearch {...childProps}/>
                            </Route>
                            <Route path={'/chat/history'}>
                                <ChatsHistory {...childProps}/>
                            </Route>
                            <Route path={'/chat/:conversationId'}>
                                <ChatSingle {...childProps}/>
                            </Route>
                            <Route path={"/chat"}>
                                <ChatsOpen {...childProps}/>
                            </Route>
                            <Route path={"/announcements"}>
                                <AgentAnnouncementIndex {...childProps}/>
                            </Route>
                            <Route path="/change-password">
                                <ChangePassword {...childProps}/>
                            </Route>
                            <Route path="/logout">
                                <Logout {...childProps}/>
                            </Route>
                            <Route path="/profile">
                                <ProfileIndex {...childProps}/>
                            </Route>
                            <Route path="/">
                                <Home {...childProps}
                                      toggleSideBar={this.onMenuToggleClick.bind(this)}
                                />
                            </Route>
                        </Switch>

                    </div>
                    <SendAgentLinkModalComponent
                        isOpen={this.state.openSendRegistrationLink}
                        handler={this.toggleSendRegistrationLink}
                    />
                </div>
            </BrowserRouter>

        </Fragment>
    }

    toggle() {
        this.setState({dropdownOpen: !this.state.dropdownOpen});
    }

    renderHeader() {

        return <Fragment>
            <div className={"header header-fixed"}>

                {
                    this.agentCanChat && this.state.numberOfConversationsWithUnreadMessages > 0 && <div
                        style={{
                            padding: 3,
                            borderRadius: 50,
                            maxWidth: 30,
                            maxHeight: 30,
                            minWidth: 30,
                            minHeight: 30,
                            textAlign: 'center',
                            position: "absolute",
                            top: 10,
                            left: 40,
                        }}
                        className={"btn-primary"}
                        onClick={this.onMenuToggleClick.bind(this)}
                    >
                        {this.state.numberOfConversationsWithUnreadMessages}
                    </div>
                }
                <Button className={"fa fa-bars nav_bar_toggle_btn"}
                        onClick={() => this.onMenuToggleClick()}/>

                <h3 className={"header-title"}>{this.state.headerText}</h3>
                {this.agentCanViewProfile && <Nav className="ml-auto" navbar>
                    <Dropdown nav isOpen={this.state.dropdownOpen} toggle={this.toggle.bind(this)}
                              className="dropdown-menu-logout-menu">
                        <DropdownToggle nav>
                            <i className="icon fa fa-user-circle-o big-icon" style={{color: '#FFFFFF', fontSize:'x-large'}}></i>
                        </DropdownToggle>
                        <DropdownMenu right className="dropdown-item-logout-menu">
                            <DropdownItem href="/profile"><i className="fa fa-user"></i> Profile</DropdownItem>
                            {/*<DropdownItem href="/logout"><i className="fa fa-lock"></i> Logout</DropdownItem>*/}
                        </DropdownMenu>
                    </Dropdown>
                </Nav>
                }
            </div>
            <div className={'header-fixed-offset'}/>
        </Fragment>
    }
}

export default AuthenticatedRouter;